<div
  id="carouselIndicators"
  class="carousel slide"
  data-ride="carousel"
  data-interval="5000"
>
  <ol class="carousel-indicators">
    <li
      *ngFor="let item of content; let i = index"
      data-target="#carouselIndicators"
      [attr.data-slide-to]="i"
      class="{{ i === 0 ? 'active' : '' }}"
    ></li>
  </ol>
  <div class="carousel-inner">
    <div
      *ngFor="let item of content; let i = index"
      class="carousel-item {{ i === 0 ? 'active' : '' }}"
    >
      <img
        class="d-block w-100"
        [src]="item.url"
        [alt]="item.title"
        [height]="minHeight"
      />
      <div
        *ngIf="item.title || item.body"
        class="carousel-caption carousel-caption-ovr d-none d-md-block"
        [ngStyle]="{ 'background-color': item.bgcolor }"
      >
        <h1 *ngIf="item.title" [ngStyle]="{ color: item.color }">
          {{ item.title }}
        </h1>
        <h3 *ngIf="item.body" [ngStyle]="{ color: item.color }">
          {{ item.body }}
        </h3>
      </div>
    </div>
  </div>
  <a
    class="carousel-control-prev"
    href="#carouselIndicators"
    role="button"
    data-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a
    class="carousel-control-next"
    href="#carouselIndicators"
    role="button"
    data-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
